import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartCategoryService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/part/category`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/part/category/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/part/category/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/part/category`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/part/category/`+Id);
    }

}
